import 'react-multi-carousel/lib/styles.css';
import * as React from 'react';
import Link from 'next/link';
import FAQ from '../components/FAQ';
import FastEasy from '../components/FastEasy';
import Button from '@mui/material/Button';
import DontWaitBannerSection from 'components/composed/sections/DontWaitBannerSection';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { NextSeo } from 'next-seo';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/router';
import { config } from '_config';

const { apiUrl } = config;
export default function ComprehensiveTrademarkSearch() {
  const [productName, setProductName] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [search, setSearch] = useState('');
  const router = useRouter();

  function handleClick(event) {
    event.preventDefault();
    router.push({
      pathname: '/search',
      query: { text: search },
    });
  }

  useEffect(() => {
    let salePage = window.location.href;
    let salePageURLArr = salePage.split('/');
    let salePageURL = (salePageURLArr[0] + '//' + salePageURLArr[2]).replace(
      /\/+$/,
      ''
    );
    let url = apiUrl + '/category/TRADEMARKS/products/prices';
    let fallbackUrl =
      `${salePageURL}/crm` + '/category/TRADEMARKS/products/prices';

    axios
      .get(url, {
        params: {
          onlyForSale: true,
          productCodes: 'TRADEMARK_Trademark_Search_Federal_State',
          processingOptions: 'STANDARD',
        },
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          setProductName(response.data[0].code.customerName);
          setProductPrice(response.data[0].price);
        }
      })
      .catch((error) => {
        if (error.request) {
          axios
            .get(fallbackUrl, {
              params: {
                onlyForSale: true,
                productCodes: 'TRADEMARK_Trademark_Search_Federal_State',
                processingOptions: 'STANDARD',
              },
              headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
              if (response.status === 200 && response.data.length > 0) {
                setProductName(response.data[0].code.customerName);
                setProductPrice(response.data[0].price);
              }
            });
        }
      });
  }, []);

  return (
    <div className="ct-search">
      <NextSeo title="Comprehensive Trademark Search" />
      <div className="banner">
        <div className="copy-wrapper">
          <div className="copy">
            <h1>Comprehensive Trademark Search</h1>
            <p>
              Identify risks to avoid any unwanted nonrefundable USPTO filings
              fees, legal expenses or rebranding costs upfront!
            </p>
            <ul>
              <li>
                <span></span>
                <p>Ensure your trademark availability</p>
              </li>
              <li>
                <span></span>
                <p>
                  Compare possible variations or patterns of similar trademarks
                </p>
              </li>
              <li>
                <span></span>
                <p>
                  Accurate reporting using official USPTO search strategies and
                  algorithms
                </p>
              </li>
              <li>
                <span></span>
                <p>Easy to read report sent electronically</p>
              </li>
            </ul>
            <Link href={`/comprehensive-search-report`}>
              <a className="orange-btn">Order My Search Report</a>
            </Link>
            <Link href={`/comprehensive-search-report`}>
              <a className="orange-btn">Learn More</a>
            </Link>
          </div>
        </div>
      </div>

      <FastEasy
        h1={'Thorough Comprehensive Trademark Search'}
        h2={'Check to ensure that there is no existing use of your Trademark.'}
        text={[
          {
            h: 'Complete Our Online Questionnaire',
            p: 'All information gathered is confidential and secured.',
          },
          {
            h: 'Comprehensive Search is Ran',
            p: 'Our specialists will run, review and compile your search report for easy viewing.',
          },
          {
            h: 'Your Detailed Report is Sent',
            p: 'You will receive your report to review for comparable variations, duplicates or competitors for your trademark.',
          },
        ]}
      />

      <div className="sides">
        <div className="sides-wrapper">
          <div className="left-side">
            <h3>Why run a search for similar trademarks?</h3>
            <p>
              Trademark Genius will search international, federal, domestic,
              state, common law and domain name databases for similar names
              comparable to your mark to avoid potential conflict.
            </p>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <input
                type="text"
                style={{
                  flex: '1 1 auto',
                  marginRight: '10px',
                  maxHeight: '52px',
                }}
                placeholder="Search trademark availability"
                value={search || ''}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    handleClick(event);
                  }
                }}
                data-hj-allow
              />
              <Typography
                className="orange-btn"
                style={{
                  cursor: 'pointer',
                  color: '#fff',
                  flex: '0 1 auto',
                  maxWidth: '90px',
                }}
                onClick={handleClick}
              >
                Search
              </Typography>
            </div>
          </div>
          <div className="right-side">
            <div className="side-box-wrapper">
              <div className="side-box-back-2"></div>
              <div className="side-box-back"></div>
              <div className="side-box">
                <div className="header-line"></div>
                <h4>Comprehensive Trademark Search</h4>
                <h5>
                  Make sure your trademark is available before you apply to
                  register it
                </h5>
                <div className="orange-box">
                  <div className="star"></div>
                  <div className="price-wrapper">
                    <div className="price">
                      {'$' + productPrice?.toFixed(2)}
                    </div>
                    <p>per trademark</p>
                  </div>
                  <div className="star"></div>
                </div>
                <ul>
                  <li>
                    <span></span>
                    <p>Email delivery of comprehensive detailed report</p>
                  </li>
                  <li>
                    <span></span>
                    <p>
                      Findings of similar names, logos or slogans registered or
                      pending with the USPTO
                    </p>
                  </li>
                </ul>
                <Link href={`/comprehensive-search-report`}>
                  <Button>Start Now</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQ leftSide={true} />

      <DontWaitBannerSection link={'/comprehensive-search-report'} />
    </div>
  );
}
